import { render, staticRenderFns } from "./DeactivationPage.vue?vue&type=template&id=08053ea4&scoped=true"
import script from "./DeactivationPage.vue?vue&type=script&lang=js"
export * from "./DeactivationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08053ea4",
  null
  
)

export default component.exports